import { EntityPro2doc } from "../../entity/EntityPro2doc";

export class DtoPro2docsDeleteRes extends EntityPro2doc {
  public message: string | null = null;
}
